import { useEffect, useRef, useState } from 'react';

export default function useTimer(
    startTime: number,
    modifier: number = 1,
    interval: number = 1000,
) {
    const [time, setTime] = useState(startTime);
    const [isRunning, setIsRunning] = useState(false);
    const timer = useRef<any>(null);

    useEffect(() => {
        setTime(startTime);
    }, [startTime]);

    function startTimer() {
        if (isRunning) {
            return;
        }

        setIsRunning(true);

        let expected = Date.now() + interval;

        timer.current = setTimeout(step, interval);

        function step() {
            const drift = Date.now() - expected;

            expected += interval;
            const actualTime = Math.max(0, interval - drift);
            setTime((prev) => prev + (actualTime / 1000) * modifier);
            timer.current = setTimeout(step, actualTime);
        }
    }

    function stopTimer() {
        clearTimeout(timer.current);
        timer.current = null;
        setIsRunning(false);
    }

    return { time, startTimer, stopTimer, isRunning, setTime };
}
